import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

// 小時記錄類型
interface PatientFlowHourlyRecord {
  patient_flow_hourly_id: number
  people_flow_device_id: number
  timestamp: string
  patient_count: number
  created_at: string
  updated_at: string
}

// 每日記錄類型
interface PatientFlowDailyRecord {
  patient_flow_daily_id: number
  people_flow_device_id: number
  date: string
  patient_count: number
  created_at: string
  updated_at: string
}

// 通用記錄類型（根據 interval 參數決定返回哪種類型）
type PatientFlowRecord = PatientFlowHourlyRecord | PatientFlowDailyRecord

interface PatientFlowRecordsData {
  records: PatientFlowRecord[]
  total: number
}

export interface UsePeopleFlowDeviceRecordsParams {
  peopleFlowDeviceId?: number
  page?: number
  pageSize?: number
  startDate?: string
  endDate?: string
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  interval?: 'hourly' | 'daily'
}

export function usePeopleFlowDeviceRecords({
  peopleFlowDeviceId,
  page = 1,
  pageSize = 10,
  startDate,
  endDate,
  sortBy,
  sortOrder = 'desc',
  interval = 'daily',
}: UsePeopleFlowDeviceRecordsParams = {}) {
  const { token } = useAuth()

  // Build query string
  const queryParams = new URLSearchParams()
  queryParams.append('page', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  if (startDate) queryParams.append('startDate', startDate)
  if (endDate) queryParams.append('endDate', endDate)
  if (sortBy) queryParams.append('sortBy', sortBy)
  if (sortOrder) queryParams.append('sortOrder', sortOrder)

  const endpoint = interval === 'hourly' ? 'hourly' : 'daily'

  const { data, error, mutate, isLoading } = useGet<ApiResponse<PatientFlowRecordsData>>(
    token && peopleFlowDeviceId
      ? `/api/people-flow-device/${peopleFlowDeviceId}/patient-flow/${endpoint}?${queryParams.toString()}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    patientFlowRecords: data?.data?.records || [],
    total: data?.data?.total || 0,
    isLoading,
    isError: error,
    mutate,
  }
}
